import { render, staticRenderFns } from "./modelCompare.vue?vue&type=template&id=39f45324&scoped=true"
import script from "./modelCompare.vue?vue&type=script&lang=js"
export * from "./modelCompare.vue?vue&type=script&lang=js"
import style0 from "./modelCompare.vue?vue&type=style&index=0&id=39f45324&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f45324",
  null
  
)

export default component.exports